
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRouter} from "vue-router";

    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        photoList: Array<Photo>;
        slideIndex: number;
        bannerSwiper: object;
        photoLength: number;
        isShowModel: boolean;
        quality: string; // 成色
        condition: string; // 车况
    }

    export default defineComponent({
        name: "reportResult",
        setup() {
            let state: State = reactive({
                photoList: [],
                slideIndex: 0,
                bannerSwiper: {},
                photoLength: 0,
                isShowModel: false,
                quality: '',
                condition: '',
            })
            const store = useStore()
            // 获取路由器实例
            const router = useRouter()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {photoList, quality, vehicleCondition} = data
                state.photoList = photoList;
                state.photoLength = photoList.length;
                                    // (markPhotoList ? markPhotoList.length : 0) +
                                    // (paintPhotoList ? paintPhotoList.length : 0) +
                                    // (defectPhotoList ? defectPhotoList.length : 0);
                state.quality = quality;
                state.condition = vehicleCondition;
            })
            return {
                state,
                router
            }
        },
        methods: {
            goPhoto(item, isAll){
                this.router.push({
                    path: '/idlefishPhotoList',
                    name: 'idlefish-PhotoList',
                    // params: {
                    //     isAll,
                    //     item: JSON.stringify(item)
                    // }
                    query: {
                        isAll,
                        item: JSON.stringify(item)
                    }
                })
            }
        }
    })
